export const APPLY_PROFILE_PIC = "APPLY_PROFILE_PIC";